import { WmsService } from '../resource'

const  WmsProductModule = {
  namespaced: true,
  state: {
    data: [],
	data_wait_ship :[],
	data_inventory_summary :[]
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    },
	SET_DATA_WAIT_SHIP (state, data) {
		state.data_wait_ship = data
	},
	SET_DATA_INVENTORY (state, data) {
		state.data_inventory_summary = data
	},
  },
  actions: {
    createData ({ commit, state }, data) {
        return WmsService.ProductCreate(data)
    },
    updateData ({ commit, state }, data) {
        return WmsService.ProductUpdate(data.id,data.payload)
    },
    deleteData ({ commit, state }, data) {
        return WmsService.ProductDelete(data)
    },
	getBarcode ({ commit, state }, data) {
        return WmsService.ProductGetBarcode(data)
    },
	async listWmsInventorySummary({ commit, state }, data) {
		try{
			const resp = await WmsService.WmsInventorySummary()
			  commit('SET_DATA_INVENTORY', resp.data== null ? [] : resp.data)
		  }
		  catch(err)
		  {
			commit('SET_DATA_INVENTORY', [])
		  }
	},
    async listData ({ commit, state }) {
      try{
        const data = await WmsService.ProductList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA', [])
      }
    },
	async listWaitShipData({commit,state},params) {
		try {
			const data = await WmsService.ProductWaitShipList(params)
			if (data.data.Data == null) 
			{
			commit('SET_DATA_WAIT_SHIP', [])
			}
			else 
			{
			commit('SET_DATA_WAIT_SHIP', data.data.Data)
			}

		}
		catch(err)
		{
			commit('SET_DATA_WAIT_SHIP', [])
		}

	}
  },
  getters: {
    getData (state) {
      return state.data
    },
	getDataWithAll (state) {
		return  [
			{ID:0,Name:"--- สินค้า --- "},...state.data ];
	  },
	getDataWaitShip (state) {
		return state.data_wait_ship
	},
	getInventortySummary (state) {
		return state.data_inventory_summary
	}
  }
}

export default WmsProductModule
